$ = jQuery;
let main = {}, productFormEvents = {}, cartDrawerEvents;
let win = $(window);
let doc = $(document);
let currencySymbol = $('body').attr('data-currency-symbol');

main = {
	defaults: {
		lastScrollTop: 0,
	},
	onInit: function() {
		let vm = this;
		vm.submenuToggle();
		vm.megamenuToggle();
		vm.megamenuNavToggle();
		vm.onCartToggle();
		vm.onAccordionToggle();
		vm.toggleHeaderSearch();
		vm.searchSuggestions();
		vm.mobileMenuNavAccordion();
		vm.cartFromTrigger();
		vm.cartNoteFunctions();
		productFormEvents.onSelectorChange();
		productFormEvents.productFormSubmit();
		productFormEvents.popupFormTrigger();
		productFormEvents.decreaseQuantity();
		productFormEvents.addQuantity();
		productFormEvents.inputQuantityChange();
		cartDrawerEvents.onRemoveItem();
	},
	onReady: function(e) {
		let vm = this;
		vm.onInit();
		vm.onResize(); // call resize on ready to trigger initial resize functions on load. Not necessary all the time.
	},
	onLoad: function(e) {
	},
	onResize: function(e) {
	},
	onScroll: function(e) {
	},
	onCartToggle: function() {
		let vm = this, el = vm.defaults;

		$('.cart-toggle').on('click', function(e) {
			e.preventDefault();
			if (!$('body').hasClass('page-cart')) {
				$('body').toggleClass('slide-cart');
			}
		});

		$('.cart-drawer-wrapper .close-cart').on('click', function() {
			$('body').removeClass('slide-cart');
		});
	},
	onAccordionToggle: function() {
		let vm = this, el = vm.defaults;

		$('.accordion-item-row .accordion-header-wrapper').on('click', function() {
			let thisWrapper = $(this).parent();
			if (thisWrapper.hasClass('active')) {
				thisWrapper.removeClass('active');
			} else {
				thisWrapper.addClass('active').siblings().removeClass('active');
			}
		});
	},
	submenuToggle: function() {
		$('.main-menu-wrapper > ul > li > a').hover(function(e) {
			e.preventDefault();
			if ($(this).parent().hasClass('has-submenu')) {
				$(this).parent().addClass('active');
				$(this).parent().siblings().removeClass('active');
			} else {
				$(this).parent().siblings().removeClass('active');
			}
		});

		$('.main-menu-wrapper .submenu-wrapper').hover(function() {
		},function(){
			$(this).parent().removeClass('active');
			$('body').removeClass('megamenu-active');
		});

		$('.header-wrapper .main-header .account-nav-wrapper a').hover(function(e) {
			e.preventDefault();
			if (!$(this).parent().hasClass('show-account-menu')) {
				$(this).parent().addClass('show-account-menu');
			}
		});

		$('.header-wrapper .main-header .account-nav-wrapper .account-nav-controls').hover(function() {
		},function(){
			console.log('unhover', $(this).parent());
			$(this).parent().removeClass('show-account-menu');
		});
	},
	megamenuToggle: function() {
		let vm = this, el = vm.defaults;

		$('.main-menu-wrapper > ul > li > a').hover(function(e) {
			e.preventDefault();
			if ($(this).parent().hasClass('has-megamenu')) {
				$(this).parent().addClass('mm-active');
				$(this).parent().siblings().removeClass('mm-active');
				$('body').addClass('megamenu-active');
			} else {
				$(this).parent().siblings().removeClass('mm-active');
				$('body').removeClass('megamenu-active');
			}
		});

		$('.main-menu-wrapper .megamenu-wrapper').hover(function() {
		},function(){
			$(this).parent().removeClass('mm-active');
			$('body').removeClass('megamenu-active');
		});
	},
	megamenuNavToggle: function() {
		let vm = this, el = vm.defaults;

		$('.megamenu-wrapper .mm-menu-has-child > a').on('click', function(e) {
			e.preventDefault();
			let thisMenu = $(this);
			let thisParentColumn = $(this).parents().eq(4); // mm-nav-wrapper
			let thisSubNav = $(this).parent().find('.nav-group-sub-menu');
			let thisSubNavChild = $(this).parent().find('.nav-group-sub-menu').children().eq(0);

			if (thisMenu.parent().hasClass('active')) {
				thisMenu.parent().removeClass('active')
				thisSubNav.css({'max-height': '0px'});
			} else {
				thisMenu.parent().addClass('active');
				thisSubNav.css({'max-height': parseInt(thisSubNavChild.outerHeight() + 14) + 'px'});
				thisMenu.parent().siblings().removeClass('active').find('.nav-group-sub-menu').css({'max-height': '0px'});
				$('.megamenu-wrapper .col-mm-nav').not(thisParentColumn).find('.mm-menu-has-child.active').removeClass('active');
				$('.megamenu-wrapper .col-mm-nav').not(thisParentColumn).find('.mm-menu-has-child .nav-group-sub-menu').css({'max-height': '0px'});
			}
		})
	},
	mobileMenuNavAccordion: function() {
		let vm = this;

		$('.header-wrapper .megamenu-wrapper .nav-heading').on('click', function() {
			if($(window).outerWidth() <= 1100) {
				if ($(this).parents().eq(1).hasClass('active')) {
					$(this).parents().eq(1).removeClass('active');
				} else {
					$(this).parents().eq(1).addClass('active').siblings().removeClass('active');
				}
			}
		});

		$('.header-wrapper .megamenu-wrapper .mobile-accordion .caret-custom').on('click', function() {
          console.log("test");
			if($(window).outerWidth() <= 1100) {
				if ($(this).parent().hasClass('active')) {
					$(this).parent().removeClass('active');
				} else {
					$(this).parent().addClass('active').siblings().removeClass('active');
					$(this).parents().eq(5).find('.has-submenu').removeClass('active');
				}
			}
		});
      $('.header-wrapper .has-submenu .caret-custom').on('click', function() {
          console.log("test");
			if($(window).outerWidth() <= 1100) {
				if ($(this).parent().hasClass('active')) {
					$(this).parent().removeClass('active');
				} else {
					$(this).parent().addClass('active');
  					// $(this).parents().eq(5).find('.has-submenu').removeClass('active');
				}
			}
		});

		$('.main-menu-wrapper > ul > li.has-submenu > a').on('click touchstart', function(e) {
			// e.preventDefault();
			if($(window).outerWidth() <= 1100) {
				if ($(this).parent().hasClass('active')) {
					$(this).parent().removeClass('active');
				} else {
					$(this).parent().addClass('active').siblings().removeClass('active');
					$(this).parents().eq(1).find('.has-megamenu .mobile-accordion').removeClass('active');
				}
			}
		})
	},
	toggleHeaderSearch: function() {
		let vm = this, el = vm.defaults;

		$('.search-trigger').on('click', function(e) {
			e.preventDefault();
			$('body').addClass('search-active');
		});

		$('.search-form-wrapper .close-search').on('click', function(e) {
			$('.search-form-wrapper .search-suggestions').html('');
			$('body').removeClass('search-active');
		})
	},
	searchSuggestions: function() {
		let vm = this, el = vm.defaults;
		let suggestionsHtml = '';

		$('.search-form-wrapper input').on('keyup', function() {
			let thisFieldValue = $(this).val();

			if (thisFieldValue.length == 0) {
				$('.search-form-wrapper .search-suggestions').addClass('no-results');
				$('.search-form-wrapper .search-suggestions').html('');
				return;
			}
			$.ajax({
					type: 'GET',
					url: `/search/suggest.json?q=${thisFieldValue}&resources[type]=product`,
					dataType: 'json',
					beforeSend: function(data) {
				},
				success: function(data) {
					let products = data.resources.results.products;
					suggestionsHtml = '';
					console.log(products);
					if (products.length > 0) {
						$('.search-form-wrapper .search-suggestions').removeClass('no-results');
						$.each(products, function(i, product) {
							let imageUrl = '';
							if (product.featured && product.featured_image != '') {
								imageUrl = product.featured;
							} else {
								imageUrl = product.image;
							}
							if (imageUrl && imageUrl != '') {
								imageUrl = Shopify.imageResize(imageUrl, '150x');
							} else {
								imageUrl = '';
							}
							suggestionsHtml += `<div class="suggestion-item">
																		<div class="suggestion-image-wrapper">
																			<a href="${product.url}">
																				<div class="product-image" style="background: url('${imageUrl}')no-repeat center / cover">
																					<img src="${imageUrl}'" alt="${product.title}"/>
																				</div>
																			</a>
																		</div>
																		<div class="product-details">
																				<p class="product-title"><a href="${product.url}"">${product.title}</a></p>
																				<p class="product-price">${currencySymbol}${theme.Currency.formatMoney(product.price * 100)}</p>
																		</div>
																	</div>`
						});
						suggestionsHtml += `<div class="see-all-suggestions">
							<a href="/search/?q=${thisFieldValue}">See all results</a>
            </div>`;
						$('.search-form-wrapper .search-suggestions').html(suggestionsHtml);
					} else {
						suggestionsHtml += `<div class="no-results">
							<p>Sorry no results found.</p>
						</div>`;
						$('.search-form-wrapper .search-suggestions').addClass('no-results');
						$('.search-form-wrapper .search-suggestions').html('');
					}
				},
				error: function() {
				}
			});
		});
	},
	cartFromTrigger: function() {
		$('#send-as-gift').on('change', function(e) {
			e.preventDefault();
			let thisIsChecked = $(this).is(':checked');
			if (thisIsChecked) {
				$('body').addClass('sg-popup-active');
			} else {
				let notePlaceHolderContent = $('.cart-footer-wrapper .note-placeholder').val('');
				$('textarea[name="note"]#Cart-note').val(notePlaceHolderContent);
				theme.CartNote.updateCartNoteAjax();
			}
		});

		$('.sendgift-popup-wrapper .close-btn, .gift-info-wrapper .row-footer .btn.back-to-cart').on('click', function(e) {
			e.preventDefault();
			$('#send-as-gift').prop('checked', false);
			$('body').removeClass('sg-popup-active');
		});

		$('#add-gift-wrapping').on('change', function(e) {
			e.preventDefault();
			let thisIsChecked = $(this).is(':checked');
			if (thisIsChecked) {
				$('body').addClass('gw-popup-active');
			} else {
				let giftwrapProductRow = $('.item-row[data-addontype="giftwrap-addon"]');
				let giftWrapProductKey = giftwrapProductRow.attr('data-itemkey');
				$.ajax({
					type: 'POST',
					url: '/cart/change.js',
					dataType: 'json',
					data: "quantity="+0+'&id='+giftWrapProductKey,
					beforeSend: function(data) {
					},
					success: function(data) {
						theme.CartPage.updateCartPage();
					},
					error: function() {
					}
				});
			}
		});

		$('.giftwrap-popup-wrapper .close-btn').on('click', function(e) {
			e.preventDefault();

			$.getJSON('/cart.js', function(cart) {
				console.log(cart);
				let cartItems = cart.items;
				if (cartItems.some(cartItem => cartItem.hasOwnProperty('_giftwrap-addon') && cartItem.properties['_giftwrap-addon'] != undefined )) {
					$('body').removeClass('gw-popup-active');
				} else {
					$('#add-gift-wrapping').prop('checked', false);
					$('body').removeClass('gw-popup-active');
				}
			});
		});

		$('#add-mangrove-tree').on('change', function(e) {
			e.preventDefault();
			let thisIsChecked = $(this).is(':checked');
			if (thisIsChecked) {
				let checkboxProductForm = $(this).parents().eq(1).find('.checkbox-product form');
				$.ajax({
					type: 'POST',
					url: '/cart/add.js',
					dataType: 'json',
					data: checkboxProductForm.serialize(),
					beforeSend: function(data) {
					},
					success: function(data) {
						theme.CartPage.updateCartPage();
					},
					error: function() {
					}
				});
				// checkboxProductForm.trigger('submit');
			} else {
				let treeProductRow = $('.item-row[data-addontype="tree-addon"]');
				let treeProductKey = treeProductRow.attr('data-itemkey');
				$.ajax({
					type: 'POST',
					url: '/cart/change.js',
					dataType: 'json',
					data: "quantity="+0+'&id='+treeProductKey,
					beforeSend: function(data) {
					},
					success: function(data) {
						theme.CartPage.updateCartPage();
					},
					error: function() {
					}
				});
			}
		});
	},
	cartNoteFunctions: function() {
		$('.cart-footer-wrapper .update-cart-note').on('click', function(e) {
			e.preventDefault();
			let notePlaceHolderContent = $('.cart-footer-wrapper .note-placeholder').val();
			if ($('.gift-wrap-controls #send-as-gift').is(':checked')) {
				injectGifteeDetails();
			} else {
				$('textarea[name="note"]#Cart-note').val(notePlaceHolderContent);
				theme.CartNote.updateCartNoteAjax();
			}
		})

		$('.cart-footer-wrapper .note-placeholder').on('keyup keydown', function() {
			$(this).parent().addClass('note-edited');
		});
	}
};

productFormEvents = {
	elements: {
		productForm: $(document).find('form[action="/cart/add"]'),
		dropDownSelector: $(document).find('.form-select-option .select-wrapper select'),
		productCarousel: $(document).find('.product-main-carousel'),
		selectedOptions: '',
		selectedVariantId: 0,
		productPageMainSection: $('.main-product-section'),
		addToCartBtn: $(document).find('form[action="/cart/add"] .add-to-cart-wrapper button[type="submit"]')
	},
	onSelectorChange: function(e) {
		let vm = this, el = vm.elements;

		el.dropDownSelector.on('change', function(e) {
			el.selectedOptions = '';
			let thisForm = $(this).closest(el.productForm);
			let thisSelectorsWrapper = $(this).closest('.form-select-option');
			let thisOptions = thisSelectorsWrapper.find('[data-option]');

			thisOptions.each(function() {
				let optionSelector = parseInt($(this).attr('data-option'));
				if (thisOptions.length > optionSelector ) {
					el.selectedOptions += $(this).find('select').val() + ' / ';
				} else {
					el.selectedOptions += $(this).find('select').val();
				}
			});

			el.selectedVariantId = thisForm.find('.product-data-select  option[data-title="'+el.selectedOptions+'"]').val();
			thisForm.find(`input[name="id"]`).val(el.selectedVariantId);
			vm.onVariantChange(el.selectedVariantId, thisForm);
		});
	},
	onVariantChange: function(variantId, prodForm) {
		let vm = this, el = vm.elements;

		vm.updateAddressBar(variantId, prodForm);
		vm.updateProductCarousel(variantId, prodForm);
		vm.updatePricePDP(variantId, prodForm);
		vm.updateButtonState(variantId, prodForm);
	},
	updateAddressBar: function(variantId, prodForm) {
		history.pushState(null, null, '?variant='+variantId);
	},
	updateProductCarousel: function(variantId, prodForm) {
		let vm = this, el = vm.elements;
		if (el.productCarousel) {
			let slideIndex = el.productCarousel.find(`.product-image[data-variant-img='${variantId}']:not('.slick-cloned')`).attr('data-slick-index');
			if (el.productCarousel.find(`.product-image[data-variant-img='${variantId}']`).length > 0) {
				el.productCarousel.slick('slickGoTo', slideIndex);
				$(`.product-thumbnail-carousel`).slick('slickGoTo', slideIndex);
			}
		}
	},
	updatePricePDP: function(variantId, prodForm) {
		let vm = this, el = vm.elements;
		let variantOptionRow = prodForm.find(`.product-data-select option[value="${variantId}"]`);
		let variantPrice = variantOptionRow.attr('price');
		let variantOldPrice = variantOptionRow.attr('old-price');

		if (el.productPageMainSection.length > 0 && variantOptionRow.length >0) {
			let productPriceWrapper = el.productPageMainSection.find('.product-price');
			productPriceWrapper.find('.new-price span').text(`${currencySymbol}${theme.Currency.formatMoney(variantPrice)}`);
			productPriceWrapper.find('.old-price span').text(`${currencySymbol}${theme.Currency.formatMoney(variantOldPrice)}`);
		}

		if ($('.giftwrap-popup-wrapper').length > 0 && variantOptionRow.length >0) {
			let productPriceWrapper = $('.giftwrap-popup-wrapper').find('.product-price');
			productPriceWrapper.find('.new-price span').text(`${currencySymbol}${theme.Currency.formatMoney(variantPrice)}`);
			productPriceWrapper.find('.old-price span').text(`${currencySymbol}${theme.Currency.formatMoney(variantOldPrice)}`);
		}
	},
	updateButtonState: function(variantId, prodForm) {
		let vm = this, el = vm.elements;
		let variantOptionRow = prodForm.find(`.product-data-select option[value="${variantId}"]`);
		let availability = variantOptionRow.attr('available');
		let thisButton = prodForm.find('.add-to-cart-wrapper button[type="submit"]');

		if (availability == 'true') {
			thisButton.find('.button-title').text('Add to Cart');
			thisButton.removeAttr('disabled');
			thisButton.removeClass('out-of-stock');
		} else {
			thisButton.addClass('out-of-stock');
			thisButton.find('.button-title').text('Out of Stock');
			thisButton.attr('disabled', true);
		}
	},
	productFormSubmit: function() {
		let vm = this, el = vm.elements;

		el.addToCartBtn.on('click', function(e) {
			e.preventDefault();
			let thisForm = $(this).closest('form[action="/cart/add"]');
			let closeGiftWrapPopup = false;
			if ($(this).hasClass('gift-wrap-add')) {
				closeGiftWrapPopup = true;
			}
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: thisForm.serialize(),
				beforeSend: function(data) {
				},
				success: function(data) {
					// console.log(data);
					$('body').removeClass('empty-cart');
					// vm.updateCartTotal();
					if ($('body').hasClass('page-cart')) {
						theme.CartPage.updateCartPage();
						if (closeGiftWrapPopup) {
							$('body').removeClass('gw-popup-active');
						}
					} else {
						$('body').addClass('slide-cart');
						setTimeout(function() {
							$('body').removeClass('slide-cart');
						}, 2500);
						theme.CartElem.updateCart();
					}
				},
				error: function() {
				}
			});
		});
	},
	popupFormTrigger: function() {
		let vm = this;

		$('.ask-details-wrapper a').on('click', function(e) {
			e.preventDefault();
			$('body').addClass('product-contact-popup-active');
		});

		$('.contact-popup-wrapper .btn-close').on('click', function() {
			$('body').removeClass('product-contact-popup-active');
		});
	},
	decreaseQuantity: function() {
		$(document).on('click', '.quantity-wrapper .btn-reduce-quantity', function(e) {
			e.preventDefault();
			var quantityInput = $(this).siblings('input.input-quantity');
			var quantity = quantityInput.val();
			if (quantity != 1) {
				quantity--;
				quantityInput.val(quantity);
				quantityInput.trigger('change');
			}
		});
	},
	addQuantity: function() {
		$(document).on('click', '.quantity-wrapper .btn-add-quantity', function(e) {
			e.preventDefault();
			var quantityInput = $(this).siblings('input.input-quantity');
			var quantity = quantityInput.val();
			quantity++;
			quantityInput.val(quantity);
			quantityInput.trigger('change');
		});
	},
	inputQuantityChange: function() {
		$(document).on('change', '.quantity-wrapper input.input-quantity', function() {
			if ($(this).attr('data-update-line') && $(this).attr('data-update-line') != '') {
				var quantity = $(this).val();
				var product_key = $(this).attr('data-update-line');
				$.ajax({
					type: 'POST',
					url: '/cart/change.js',
					dataType: 'json',
					data: "quantity="+quantity+'&id='+product_key,
					beforeSend: function(data) {
					},
					success: function(data) {
						theme.CartElem.updateCart();
						theme.CartPage.updateCartPage();
					}
				});
			}
		});
	}
}

cartDrawerEvents = {
	elements: {},
	onRemoveItem: function() {
		let vm = this, el = vm.elements;

		$(document).on('click', '.cart-drawer-wrapper .line-item .remove-item', function(e) {
			e.preventDefault();
			let thisItemKey = $(this).attr('data-itemkey');
			$.ajax({
				type: 'POST',
				url: '/cart/change.js',
				dataType: 'json',
				data: "quantity="+0+'&id='+thisItemKey,
				beforeSend: function(data) {
				},
				success: function(data) {
					theme.CartElem.updateCart();
				}
			});
		})
	}
}

doc.ready(function() {
	main.onReady();
});

win.on('load', function() {
	main.onLoad();
});

win.resize(function() {
	main.onResize();
});

win.scroll(function() {
	main.onScroll();
});

Shopify.handleize = function (str) {
	return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

Shopify.imageResize = function (str, size) {
	let newImageUrl = '';
	if (!size) {
		size = '300x';
	}
	if (str.indexOf('.jpg') > -1) {
		newImageUrl = str.replace(".jpg", `_${size}.jpg`);
	} else if (str.indexOf('.gif') > -1) {
		newImageUrl = str.replace(".gif", `_${size}.gif`);
	} else if (str.indexOf('png') > -1) {
		newImageUrl = str.replace(".png", `_${size}.png`);
	}
	return newImageUrl
}

window.theme = window.theme || {};
theme.Currency = (function() {
  function formatMoney(cents, format) {
		let formatedPrice = (cents / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    return formatedPrice;
  }

  return {
    formatMoney
  };
})();

window.theme = window.theme || {};
theme.CartElem = (function() {
	function updateCart() {
		$.getJSON('/cart.js', function(cart) {
			console.log(cart);
			let itemCount = cart.item_count;
			if (itemCount > 0) {
				$('.cart-item-count').text(itemCount);
				$('body').removeClass('empty-cart');
			} else {
				$('body').addClass('empty-cart');
			}
			buildItemRows(cart);
			updateCartTotal(cart.total_price)
		});
	}
	function buildItemRows(cartObj) {
		let cartItems = cartObj.items;
		let itemRowHTML = '';

		cartItems.forEach((cartItem) => {
			itemRowHTML += `<div class="line-item" data-itemkey="${cartItem.key}">
				<div class="item-row">
						<div class="product-image-wrapper">
								<div class="product-image" style="background: url('${cartItem.image}')no-repeat center / cover;">
										<img src="${cartItem.image}" alt="${cartItem.title}"/>
										<a href="${cartItem.url}"></a>
								</div>
						</div>
						<div class="product-details">
								<div class="product-info">
										<p class="product-title"><a href="${cartItem.url}">${cartItem.product_title}</a></p>
										<p class="product-price">
												<span class="new-price">${currencySymbol}${theme.Currency.formatMoney(cartItem.price)}</span>`
												if (cartItem.original_price > cartItem.price) {
												itemRowHTML += `<span class="old-price">${currencySymbol}${theme.Currency.formatMoney(cartItem.original_price)}</span>`
												}
									itemRowHTML +=`</p>
								</div>
								<div class="other-details">`
										if (cartItem.variant_options.length > 0) {
											let variantOptions = cartItem.variant_options;
											itemRowHTML +=`<div class="variant-titles">`
											variantOptions.forEach((varOption) => {
												itemRowHTML += `<p class="small-label">${varOption}</p>`
											})
											itemRowHTML += `</div>`
										}
										itemRowHTML += `<div class="quantity-wrapper v2">
												<span class="btn-quantity-control btn-reduce-quantity">&ndash;</span>
														<input
																type="number"
																id="quantity-drawer-${cartItem.id}"
																class="input-quantity"
																name="quantity"
																value="${cartItem.quantity}"
																min="1"
																data-update-line="${cartItem.key}"
														>
												<span class="btn-quantity-control btn-add-quantity">+</span>
										</div>`
										itemRowHTML += `<div class="remove-item-wrapper">
												<a href="/cart/change?id=${cartItem.key}&amp;quantity=0" class="remove-item" data-itemkey="${cartItem.key}">Remove</a>
										</div>
								</div>
						</div>
				</div>
		</div>`
		});

		$('.cart-drawer-wrapper .line-item-wrapper').html(itemRowHTML);
	}
	function updateCartTotal(cartTotalPrice) {
		$('.cart-drawer-wrapper .sub-total-amount span').text(currencySymbol + theme.Currency.formatMoney(cartTotalPrice));
	}

	return {
		updateCart
	};
})();

window.theme = window.theme || {};
theme.CartPage = (function() {
	function updateCartPage() {
		$.getJSON('/cart.js', function(cart) {
			console.log(cart);
			let itemCount = cart.item_count;
			if (itemCount > 0) {
				$('.cart-item-count').text(itemCount);
				$('body').removeClass('empty-cart');
			} else {
				$('body').addClass('empty-cart');
			}
			buildCartItemRows(cart);
			updateCartPageTotal(cart.total_price)
		});
	}
	function buildCartItemRows(cartObj) {
		let cartItems = cartObj.items;
		let itemRowHTML = '';

		console.log('cart items', cartItems);

		cartItems.forEach((cartItem) => {
			let imageUrl = '';
			let addOnType = '';
			let itemProps = cartItem.properties;
			if (cartItem.featured && cartItem.featured_image != '') {
				imageUrl = cartItem.featured;
			} else {
				imageUrl = cartItem.image;
			}
			if (imageUrl && imageUrl != '') {
				imageUrl = Shopify.imageResize(imageUrl, '150x');
			} else {
				imageUrl = '';
			}

			if (itemProps && itemProps.hasOwnProperty('_tree-addon')) {
				addOnType = 'data-addontype=tree-addon';
			}

			if (itemProps && itemProps.hasOwnProperty('_giftwrap-addon')) {
				addOnType = 'data-addontype="giftwrap-addon"';
			}

			itemRowHTML += `<div class="item-row" data-itemkey="${cartItem.key}" ${addOnType}>
								<div class="col-product-details">
									<div class="product-image-wrapper">
										<div class="product-image" style="background: url('${imageUrl}')no-repeat center / cover;">
											<img src="${imageUrl}" alt="${cartItem.title}">
											<a href="${cartItem.url}"></a>
										</div>
									</div>
									<div class="product-details">
										<p class="product-title"><a href="${cartItem.url}">${cartItem.product_title}</a></p>
										<p class="product-price">
											<span class="new-price"><span class="money">${currencySymbol}${theme.Currency.formatMoney(cartItem.price)}</span></span>`
											if (cartItem.original_price > cartItem.price) {
												itemRowHTML += `<span class="old-price">${currencySymbol}${theme.Currency.formatMoney(cartItem.original_price)}</span>`
												}
										itemRowHTML +=`</p>
										<div class="other-details">
											<div class="variant-titles">`
											if (cartItem.variant_options.length > 0) {
												let variantOptions = cartItem.variant_options;
												itemRowHTML +=`<div class="variant-titles">`
												variantOptions.forEach((varOption) => {
													itemRowHTML += `<p class="small-label">${varOption}</p>`
												})
												itemRowHTML += `</div>`
											}
											itemRowHTML += `</div>
											<div class="remove-item-wrapper">
												<a href="/cart/change?id=${cartItem.key}&amp;quantity=0" class="remove-item" data-itemkey="${cartItem.key}">Remove</a>
											</div>
										</div>
									</div>
								</div>
								<div class="col-quantity">
									<div class="quantity-wrapper v2">
										<span class="btn-quantity-control btn-reduce-quantity">&ndash;</span>
											<input
												type="number"
												id="quantity-drawer-${cartItem.id}"
												class="input-quantity"
												name="quantity"
												value="${cartItem.quantity}"
												min="1"
												data-update-line="${cartItem.key}"
											>
										<span class="btn-quantity-control btn-add-quantity">+</span>
									</div>
								</div>
								<div class="col-line-price">
									<div class="line-price-wrapper">
										<p><span class="money">${currencySymbol}${theme.Currency.formatMoney(cartItem.line_price)}</span></p>
									</div>
								</div>
							</div>`
		});

		$('.cart-contents .cart-items-row-wrapper').html(itemRowHTML);
	}
	function updateCartPageTotal(cartTotalPrice) {
		$('.sub-total-amount p span.money').text(currencySymbol + theme.Currency.formatMoney(cartTotalPrice));
		$('.cart-drawer-wrapper .sub-total-amount span').text(currencySymbol + theme.Currency.formatMoney(cartTotalPrice));
	}

	return {
		updateCartPage
	};
})();

window.theme = window.theme || {};
theme.CartNote = (function() {
	function updateCartNoteAjax() {
		// console.log('updateCartNote');
		let cartNoteValue = $('textarea[name="note"]#Cart-note').val();
		$.ajax({
			url: '/cart/update.js',
			type: 'POST',
			data: {
				note: cartNoteValue
			},
			success: function(result) {
				// console.log('cart', result);
				location.reload();
			},
			error: function(jqxhr, status, exception) {
				// console.log(exception);
			}
		});
	}

	return {
		updateCartNoteAjax
	};
})();

// $('.shop-by-brand .product-grid-wrapper').slick({
//   dots: false,
//   slidesToShow: 5,
//   slidesToScroll: 4,
//   infinite: false,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//   slidesToShow: 5,
//   slidesToScroll: 4,
//         accessibility: false
//       }
//     },
//     {
//       breakpoint: 992,
//   slidesToShow: 3,
//   slidesToScroll: 1
//     }
//   ]
// });

// 
// $(document).load(function() {
  $(window).on('load', function() {
	// $('.shop-by-brand .product-grid-wrapper').slick({
	// 	dots: false,
	// 	arrows: false,
	// 	infinite: false,
	// 	adaptiveHeight: true,
	// 	slidesToShow: 5,
	// 	slidesToScroll: 5,
 //                  accessibility: false,
	// 	responsive:
	// 	[
 //            {
	// 			breakpoint: 1600,
	// 			settings: {
	// 	arrows: true,
	// 	prevArrow: '<span class="slick-arrow slick-prev"></span>',
	// 	nextArrow: '<span class="slick-arrow slick-next"></span>',
 //                  accessibility: false,
 //                    arrows : false,
	// 				slidesToShow: 4,
	// 				slidesToScroll: 5
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 1025,
	// 			settings: {
	// 	arrows: true,
	// 	prevArrow: '<span class="slick-arrow slick-prev"></span>',
	// 	nextArrow: '<span class="slick-arrow slick-next"></span>',
	// 				slidesToShow: 4,
 //                  accessibility: false,
	// 				slidesToScroll: 5
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 790,
	// 			settings: {
	// 	arrows: true,
	// 	prevArrow: '<span class="slick-arrow slick-prev"></span>',
	// 	nextArrow: '<span class="slick-arrow slick-next"></span>',
	// 				slidesToShow: 4,
 //                  accessibility: false,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
  var hold = false;
$("#hold").click(function() {
  slider.slick("slickSetOption", "accessibility", hold);
  slider.slick("slickSetOption", "draggable", hold);
  slider.slick("slickSetOption", "swipe", hold);
  slider.slick("slickSetOption", "touchMove", hold);
  
  hold = !hold;
  
  $(this).toggleClass("disabled");
});
});
// 